const ITEMS = ["Understand", "Personalize", "Support", "Empower", "Holistic Healing. Brighter Tomorrows."];

const Row = () => (
  <div className="flex items-center shrink-0">
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className={`px-8 font-serif text-2xl lg:text-3xl ${i === 4 ? "italic text-[#B85D43]" : "text-[#1B3B2B]"}`}>
          {t}
        </span>
        <span className="w-1.5 h-1.5 rounded-full bg-[#C5A059]" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section aria-hidden="true" data-testid="editorial-marquee" className="overflow-hidden bg-[#F4EFE6] border-b border-[#E5D3AD]/50 py-6">
      <div className="marquee-track flex">
        <Row />
        <Row />
      </div>
    </section>
  );
}
